import { render, staticRenderFns } from "./orderBy.vue?vue&type=template&id=39dea288&scoped=true&"
import script from "./orderBy.vue?vue&type=script&lang=js&"
export * from "./orderBy.vue?vue&type=script&lang=js&"
import style0 from "./orderBy.vue?vue&type=style&index=0&id=39dea288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dea288",
  null
  
)

export default component.exports